export const getPayload = ({ id, name, lastName, username, email, image, group, otherStoresGroups }) => {
  const form = new FormData()
  if (id !== 'new') form.append('id', id)
  form.append('first_name', name)
  form.append('last_name', lastName)
  form.append('username', username)
  form.append('email', email)
  if (image?.file) form.append('profile_picture', image.file)
  form.append('groups', group)
  otherStoresGroups?.forEach(g => form.append('groups', g))

  return form
}

export const validateUsername = username => {
  const regex = /^[A-Za-z0-9+_\-.]{0,24}$/

  return regex.test(username)
}
